<template>
  <div id="liveplayer">
    <!--视频位置-->
    <div class="video">
      <div id="livePolyv"></div>
    </div>
    <div class="chatroom">
      <div id="wrap"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LivePlayer',
  data () {
    return {
      liveUid: '5111745181', // 直播账号
      liveVid: '403288', // 直播频道号
      player: null, // 定义播放器
      polyvChatRoom: null,
      videoId: this.$route.query.video_id ? this.$route.query.video_id : 1528, // 获取video_id
      roomName: '',
      polyvToken: '123456', // 聊天室参数 token
      polyvMediaChannelKey: '123456', // 聊天室参数 mediaChannelKey
      nickName: this.$store.state.nickname ? this.$store.state.nickname : '游客' + new Date().getTime().toString(),
      uid: this.$store.state.uid ? this.$store.state.uid : 'abcdefghijklmn-uid',
      userId: this.$store.state.userid ? this.$store.state.userid : 'abcdefghijklmn-userid',
      roomStatus: 1 // 直播状态 当前房间状态 1 未开始  2 已转存 3 正在直播
    }
  },
  methods: {
    getVideo () {
      if (this.liveVid) {
        this.player = window.polyvObject('#livePolyv').livePlayer({
          width: '7.5rem',
          height: '4.24rem',
          uid: this.liveUid,
          vid: this.liveVid,
          param1: this.userId,
          param2: this.$store.state.name,
          param4: this.uid,
          forceH5: true
        })
      }
    },
    getChatRoom () {
      var roomMessage = function (data) {
        console.log(data)
      }
      this.polyvChatRoom = new window.PolyvChatRoom({
        container: '#wrap',
        width: '100%',
        height: '100%',
        nick: this.nickName,
        pic: 'http://livestatic.videocc.net/assets/wimages/missing_face.png',
        userId: this.userId,
        // userType: 'teacher',
        roomId: this.liveVid, // 频道号
        roomMessage: roomMessage,
        // enableSetNickname: true,
        token: this.polyvToken,
        mediaChannelKey: this.polyvMediaChannelKey,
        enableFlower: false,
        enableLike: false,
        // enableAsk: false,
        // enableOnlyTeacher: false,
        tabData: [{
          name: '聊天',
          type: 'chat'
        }, {
          name: '在线',
          type: 'user-list'
        }, {
          name: '提问',
          type: 'ask'
        }]
      })
    },
    // 获得直播信息
    getLiveMsg () {
      let data = {
        video_id: this.videoId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_course_live',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.liveVid = res.data.data.channelId
            this.roomName = res.data.data.name
            this.polyvToken = res.data.data.polyv_token
            this.polyvMediaChannelKey = res.data.data.polyv_mediaChannelKey
            this.roomStatus = res.data.data.status
            this.getVideo()
            this.getChatRoom()
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  mounted () {
    this.getLiveMsg()
  }
}
</script>

<style scoped lang="stylus">
  #liveplayer
    .video
      width: 7.5rem
      height: 4.24rem
      background: url(../../assets/img/liveplay_bg_video.png) no-repeat center
      -webkit-background-size: 100%
      background-size: 100%
    .chatroom
      width: 7.5rem
      height: 7.82rem
      #wrap
        width: 100%
        height: 100%
</style>



// WEBPACK FOOTER //
// src/components/play/LivePlayer.vue